import numeral from 'numeral';

/**
 * Format a number as a string value to display as a metric. Long numbers will
 * be abbreviated with a single-letter suffix, e.g. '1.5k'.
 */
const formatRoundedNumber = (value: number) => numeral(value).format('0.[0]a');

export default formatRoundedNumber;
